export default {
  methods: {
    customFilter (item, queryText, itemText) {
      let stringTags = item.tags ? item.tags.toString() : ''

      return itemText.indexOf(queryText) > -1 || stringTags.indexOf(queryText) > -1
    },
    preventNonNumericalInput (e) {
      e = e || window.event
      let charCode = (typeof e.which === 'undefined') ? e.keyCode : e.which
      let charStr = String.fromCharCode(charCode)

      if (!charStr.match(/^[0-9]+$/)) {
        e.preventDefault()
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly
    },
    formatCurrencyValue (data) {
      // Regular Expression: Currency format & forbid leading zeros
      let currencyValueRegExp = new RegExp('^(?!0\\.00)[1-9]\\d{0,2}(?:,\\d{3})*(\\.?\\d*)$')

      // Test input value (Trim ALL Whitespace)
      if (currencyValueRegExp.test(data.replace(/\s+/g, ''))) {
        // Keep only number and dot
        data = data.replace(/[^\d.]/g, '')
      }

      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mixins/utils.js